var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompletedFinetuningIcon = function SvgCompletedFinetuningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 96,
    fill: "none",
    className: "svgr-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#completed-finetuning-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9ED7EE",
    d: "M71.061 30.382C77.103 30.382 82 25.509 82 19.498S77.103 8.613 71.061 8.613c-6.04 0-10.938 4.873-10.938 10.885 0 6.01 4.897 10.884 10.938 10.884"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0EAF8",
    d: "M60.91 8.3c2.303 0 4.17-1.858 4.17-4.15S63.214 0 60.91 0s-4.171 1.858-4.171 4.15 1.867 4.15 4.17 4.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ED7EE",
    d: "M10.939 86.134c6.04 0 10.938-4.873 10.938-10.884S16.98 64.365 10.94 64.365 0 69.238 0 75.25c0 6.01 4.897 10.884 10.939 10.884"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0EAF8",
    d: "M18.887 96.078c2.303 0 4.17-1.858 4.17-4.15s-1.867-4.15-4.17-4.15-4.171 1.858-4.171 4.15 1.867 4.15 4.17 4.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7BB82A",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M44.305 86.134c19.688 0 35.649-15.881 35.649-35.472 0-19.59-15.96-35.471-35.649-35.471-19.688 0-35.649 15.881-35.649 35.471s15.961 35.472 35.65 35.472Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.812 57.24c1.574 4.15 3.541 7.987 6.06 11.589.865 1.33 2.518 1.174 3.383 0 8.735-11.51 17.55-22.943 26.914-33.906 1.652-1.879-1.102-4.698-2.754-2.74C49.814 43.38 40.843 55.126 31.87 66.87h3.384a55.4 55.4 0 0 1-5.666-10.65c-.865-2.348-4.643-1.409-3.777 1.019"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "completed-finetuning-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h82v96H0z"
  })))));
};
export default SvgCompletedFinetuningIcon;